module.exports = __webpack_public_path__ + "static/question-3cade397d4627c5064f37d5f8841a9fa.png";